
<template lang="html">
<div>

    <div class="subpage affairs2">

          <div class="pgLeft">流程</div>
          <div class="pgContent">
                <el-button class="addbtn" @click="addPgress" size="small" type="primary">添加</el-button>
                <div class="text-block clearfix" v-for="(item,index) in params.processFlowList">
                    <div class="bName">
                          <dic-select code="bllc"
                               :selectId="item.processTypeId"
                               :paramsKey="index"
                               @selectChange="selectChange"/>
                    </div>
                    <div class="bContent">
                          <el-input type="textarea" rows="5" resize="none" size="medium" class="inpText" v-model="item.content" placeholder="请输入内容"></el-input>
                          <el-button @click="pgRemove(index)" class="rmbtn" size="small" type="danger">删除</el-button>
                    </div>
                </div>

          </div>

    </div>

</div>
</template>

<script>
import { getpGress } from "@/api/affairs/affairs";
export default {
    props:['affid'],
    data(){
        return{
            params:{
                processFlowList:[],
            }
        }
    },

    methods:{
        saveReturn:function(){

            var newArr = [];
            this.params.processFlowList.forEach((item,index) => {
               if(item.processTypeId && item.content){
                  newArr.push({
                      cqjZhengwuHandleMattersId:item.cqjZhengwuHandleMattersId,
                      processTypeId:item.processTypeId,
                      processType:item.processType,
                      content:item.content
                  })
               }
            })

            if(newArr.length > 0){
               return {processFlowList:newArr};
            }else{
               return false;
            }


        },
        addPgress:function(){
            this.params.processFlowList.push({
                 cqjZhengwuHandleMattersId:this.affid,
                 processTypeId:'',
                 content:''
            });
        },
        pgRemove:function(inx){
            this.params.processFlowList.splice(inx,1);
        },
        selectChange:function(e){
            this.params.processFlowList[e.paramsKey].processTypeId = e.id;
            this.params.processFlowList[e.paramsKey].processType = e.name;
        },
        preEdit:function(res){
            this.params.processFlowList = res.processFlowList;
        }
    }
}
</script>

<style lang="scss" scoped>

.affairs2{
      font-size: 14px;
     .pgLeft{
          width: 60px;
          float: left
     }
     .pgContent{
          margin-left: 60px;
          position: relative;
          .addbtn{
               width: 90px;
               margin-bottom: 20px;
          }

          .rmbtn{
               vertical-align: text-top;
               margin-left: 12px;
          }
     }
     .cblock{

     }
}

.text-block{
      font-size: 14px;
     .bName{
          width: 240px;
          padding-top: 2px;
          float: left;
          // text-align:right;
     }
     .bContent{
          margin-left: 240px;
          position: relative;
          margin-bottom: 20px;

          .inpText{
              width: 80%;
              vertical-align: text-top;
          }

          .tips{
              font-size: 12px;
              color: #AeAEAE;
              margin-top: 12px;
              margin-left: 12px;
          }

          .minspan{
              margin: 0 6px;
          }

          .inpLoc{
              width: 475px;
          }

          .locLine{
              margin-top: 12px;
              .remove-btn{
                  color: salmon;
                  margin-left: 12px;
                  cursor: pointer;
              }

          }
     }
}

</style>



// WEBPACK FOOTER //
// Subpage2.vue?819283dc